export const REGISTER_GRID = 'GRID.REGISTER_GRID';
export const UNREGISTER_GRID = 'GRID.UNREGISTER_GRID';
export const REFRESH_GRID = 'GRID.REFRESH_GRID';
export const REFRESH_ALL = 'GRID.REFRESH_ALL';
export const GRID_REFRESHED = 'GRID.GRID_REFRESHED';
export const LOAD_GRID_DATA = 'GRID.LOAD_GRID_DATA';
export const SORT_GRID = 'GRID.SORT_GRID';
export const FILTER_GRID = 'GRID.FILTER_GRID';
export const FILTER_HOME_PAGE_GRID = 'GRID.FILTER_HOME_PAGE_GRID'
export const TOGGLE_ADVANCED_SEARCH = 'GRID.TOGGLE_ADVANCED_SEARCH';
export const SHOW_ADVANCED_SEARCH = 'GRID.SHOW_ADVANCED_SEARCH';
export const REFRESH_RECIPIENT = 'GRID.REFRESH_RECIPIENT'
export const REFRESH_IB_RECIPIENT = 'GRID.REFRESH_IB_RECIPIENT'
export const REFRESH_MANAGEMENT = 'GRID.REFRESH_MANAGEMENT'
export const REFRESH_PAGINATION = 'GRID.REFRESH_PAGINATION'
export const REFRESH_SORT = 'GRID.REFRESH_SORT';

export const CHANGE_PAGE_LENGTH = 'GRID.CHANGE_PAGE_LENGTH';
export const GOTO_PAGE = 'GRID.GOTO_PAGE';
export const NEXT_PAGE = 'GRID.NEXT_PAGE';
export const PREV_PAGE = 'GRID.PREV_PAGE';
export const FIRST_PAGE = 'GRID.FIRST_PAGE';
export const LAST_PAGE = 'GRID.LAST_PAGE';
export const COUNTRY_GRID_ACTION = 'GRID.COUNTRY_GRID_ACTION';
export const SN_GRID_ACTION = 'GRID.SN_GRID_ACTION';
